import { axiosInstance } from "@/api/apiClient";
import {
  BusinessApi,
  BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest,
  BusinessApiUsersViewsNinjaBusinessGetBusinessRequest,
  BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest,
  BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest,
  BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new BusinessApi(undefined, BASE_API, axiosInstance);

export const getBusinessBalance = async (
  payload: BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest
) => {
  return api.usersViewsNinjaBusinessGetBusinessBalance.bind(api)(payload);
};

export const getBusiness = async (
  payload: BusinessApiUsersViewsNinjaBusinessGetBusinessRequest
) => {
  return api.usersViewsNinjaBusinessGetBusiness.bind(api)(payload);
};

export const getBusinessChannelToken = async (
  payload: BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest
) => {
  return api.usersViewsNinjaBusinessGetChannelToken.bind(api)(payload);
};

export const submitSurveyRequest = async (
  payload: BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest
) => {
  return api.usersViewsNinjaBusinessSubmitSurvey.bind(api)(payload);
};

export const surveySnooze = async (
  payload: BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest
) => {
  return api.usersViewsNinjaBusinessSurveySnooze.bind(api)(payload);
};
